import * as React from 'react';
import TransportLetterForm from './TransportLetterForm';
import {ErrorResponse, RentalDocumentType, TransportDto} from '../api/dtos/dtos';
import {ErrorAlert} from '../common/ErrorAlert';
import furoApi from '../api/FuroApi';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import locales from "../locales";
import {openPdf} from "../utils/file-utils";

interface Props {
  rentalId: number;
  siteAddress?: string;
  onClose: () => void;
}

interface State {
  transport?: TransportDto;
  error?: ErrorResponse;
}

class RentalTransportLetterEditor extends React.Component<Props, State> {

  public state: State = {};
  public readonly loadingHandler?: LoadingOverlayHandler;

  public componentDidMount(): void {
    this.reload();
  }

  public render(): React.ReactNode {
    const {error, transport} = this.state;
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <TransportLetterForm
          transport={transport}
          onCancel={this.props.onClose}
          onDownload={this.onDownload}
          onSave={this.onFormSubmit}
        />

        {error && <ErrorAlert style={{marginTop: '16px'}} error={error}/>}
      </>
    );
  }

  private onFormSubmit = (transport: TransportDto) => {
    const {rentalId} = this.props;
    const promise = furoApi.rentals.saveTransport(rentalId, transport)
      .then(this.props.onClose)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private reload = () => {
    const {rentalId} = this.props;
    const promise = furoApi.rentals.getTransport(rentalId)
      .then(this.onReloadSuccess)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onReloadSuccess = (response: TransportDto) => {
    const transport = response || {
      start: locales.start_address_default,
      end: this.props.siteAddress,
    };
    this.setState({
      transport,
      error: undefined,
    });
  };

  private onDownload = () => {
    const {rentalId} = this.props;
    const promise = furoApi.document.getRentalDocument(rentalId, RentalDocumentType.TRANSPORT_LETTER)
      .then(openPdf)
      .then(this.props.onClose)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  };
}

export default RentalTransportLetterEditor;



// WEBPACK FOOTER //
// ./src/rental-details/RentalTransportLetterEditor.tsx